import { DeploymentService } from "./../../../../core/services/deployment.service";
import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ConfigEntities } from "src/app/core/models/config-entities";
import {
  Deployment,
  DeploymentJsonBody,
  DeploymentParameter,
  PartitionProp,
} from "src/app/core/models/deployment";
import { NavigationService } from "./../../../../core/services/navigation.service";
import { NgxSpinnerService } from "ngx-spinner";
import { CoreUsage, StorageUsage } from "src/app/core/models/charts";
import { Job } from "src/app/core/models/job";
import { ManageTooltipService } from "src/app/core/services/manage-tooltip.service";
import { Node } from "src/app/core/models/node";
import { ReplaySubject, Subject, Subscription, takeUntil } from "rxjs";
import { UserService } from "../../../../core/services/user.service";
import { AuthenticationService } from "../../../../core/services/authentication.service";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CloudTypes, Entities } from "../../../../core/models/globals";
import { NewUpdatePartitionComponent } from "../../modals/new-update-partition/new-update-partition.component";
import { ConfirmDialogComponent } from "../../../shared/components/confirm-dialog/confirm-dialog.component";
import { JobConfirmationDialogComponent } from "../../../job/modals/jobActions/job-confirmation-dialog/job-confirmation-dialog.component";
import { PoweroffConfirmationComponent } from "../../modals/poweroff-confirmation/poweroff-confirmation.component";
import { HttpErrorResponse } from "@angular/common/http";
import { DeleteDeploymentComponent } from "../../modals/delete-deployment/delete-deployment.component";
import { JobOutputDialogComponent } from "src/app/modules/job/modals/jobActions/job-output-dialog/job-output-dialog.component";
import { UpdateNodeGroupComponent } from "../../modals/update-node-group/update-node-group.component";
import { StorageService } from "src/app/core/services/storage.service";
import { Storage } from "src/app/core/models/storage";
import { SessionService } from "src/app/core/services/session.service";
import { Session } from "src/app/core/models/session";
import { Users } from "src/app/core/models/users";
import { CloudProvider } from "src/app/core/models/cloudProvider";
import { EnvironmentService } from "src/app/core/services/environment.service";

@Component({
  selector: "app-deployment-summary",
  templateUrl: "./deployment-summary.component.html",
  styleUrls: ["./deployment-summary.component.scss"],
  // encapsulation: ViewEncapsulation.None,
})
export class DeploymentSummary implements OnInit, OnDestroy {
  searchTerm: string = "";
  configEntities: ConfigEntities[];
  role = this.authenticationService.getRole() || "";
  depName =
    this.route.snapshot.params["deploymentName"] ||
    this.route.parent.snapshot.params["deploymentName"];
  showValidityFlag: boolean = false;
  deployment: Deployment;
  actionValue: number = 0;
  jobs: Job[];
  daysRemaining: number;
  storageData: StorageUsage[] = [];
  coresData: CoreUsage[] = [];
  nodes: Node[] = [];
  nodeDataRequestSub: Subscription;
  tempVmName;
  autoScaleActive: boolean = false;
  noOfWorkstations: number = 0;
  succeededJobs: number = 0;
  failedJobs: number = 0;
  cancelledJobs: number = 0;
  completedJobs: number = 0;
  totalJobsCompleted = 0;
  totalcores: number = 0;
  tooltipHtml = "";
  allChartsData = [];
  isVDIDeployment: boolean = false;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  uniSub: Subscription;
  allDepPartitions: PartitionProp[] = [];
  partitionsAvailable: boolean = true;
  showGCPPartitionTable: boolean = false;
  isOnPremise: boolean = false;
  cloudType: string;
  isUserGlobalAdmin: boolean = this.authenticationService.isUserGlobalAdmin;
  showPartitionDetails: boolean = true;
  showOnlyPartitionCreateButton: boolean = false;
  storage: Storage;
  sessions: Session[];
  usersAttached: Users[] = [];
  cloudProviders: CloudProvider[];
  providerImagePath: string =
    this.environmentService.envVariables.providerImagePath;

  actions = [
    { text: "Start Nodes", value: 1 },
    { text: "Stop Nodes", value: 2 },
  ];

  constructor(
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private route: ActivatedRoute,
    private navService: NavigationService,
    private depService: DeploymentService,
    private spiner: NgxSpinnerService,
    private tooltipJson: ManageTooltipService,
    private _dialog: MatDialog,
    private snackBar: MatSnackBar,
    private router: Router,
    private storageService: StorageService,
    private sessionService: SessionService,
    private environmentService: EnvironmentService
  ) {}

  ngOnDestroy(): void {
    this.destroyed$.next(null);
    this.destroyed$.complete();
    this.uniSub.unsubscribe();
  }

  ngOnInit(): void {
    this.cloudType =
    this.route.snapshot.params["cloudType"] ||
    this.route.parent?.snapshot.params["cloudType"];
    this.navService.sendCloud(this.cloudType);
    this.navService.subNavData(Entities.Home);
    if (this.cloudType == CloudTypes.OnPremise) {
      this.isOnPremise = true;
    }
    this.getValidity();
    this.spiner.show();
    this.navService.sendParentData("Home");
    this.navService.sendLeftPanelIndex(0);
    this.getAllCloudProviders();
    this.uniSub = this.depService.getDeployment(this.depName).subscribe({
      next: async (data) => {
        this.deployment = <Deployment>JSON.parse(JSON.stringify(data));
        this.storageService.getStorage(this.deployment.storageAccountName, this.depName).subscribe((d) =>{
          this.storage = <Storage>JSON.parse(JSON.stringify(d));
        });

        await this.sessionService.getAllSessions().subscribe((data) => {
          this.sessions = <Session[]>JSON.parse(JSON.stringify(data));
        });

        if (
          this.deployment.numOfComputeNodes === -1 &&
          this.deployment.headNodeIp === "NA"
        ) {
          this.isVDIDeployment = true;
          this.partitionsAvailable = false;
          this.deployment.numOfComputeNodes = 0;
        }
        if (this.deployment.partitionProp) {
          this.partitionsAvailable = true;
          this.allDepPartitions = <PartitionProp[]>(
            JSON.parse(JSON.stringify(this.deployment.partitionProp))
          );
        } else {
          this.partitionsAvailable = false;
        }
        if (
          this.deployment.cloud?.toLowerCase() ==
          CloudTypes.Google?.toLowerCase()
        ) {
          this.showGCPPartitionTable = true;
          this.showPartitionDetails = false;
        }
        else if(
          this.deployment.cloud?.toLowerCase() ==
          CloudTypes.KVM?.toLowerCase() || this.deployment.scheduler?.toLowerCase() == "kube"
        ){
          this.showPartitionDetails = true;
          this.showOnlyPartitionCreateButton = true;
        }
        this.spiner.hide();
      },
      error: (err) => {
        this.spiner.hide();
      },
    });
    this.userService.getAllDeploymentUsers(this.depName).subscribe((data) => {
      this.usersAttached = <Users[]>JSON.parse(JSON.stringify(data));
    });
  }

  /*  to show the days remaining  */
  getValidity() {
    this.userService.getUserValidity().subscribe((data) => {
      this.daysRemaining = JSON.parse(JSON.stringify(data));
      if (this.role == "Global Admin") {
        this.showValidityFlag = true;
      } else {
        this.showValidityFlag = false;
      }
    });
  }

  getTooltip(tooltipOf: string) {
    this.tooltipHtml = null;
    this.tooltipHtml = this.tooltipJson.getTooltipOf("deployment", tooltipOf);
  }

  addNewPartition(onlySlurm = true) {
    if(this.deployment?.isVdi) {
      const dialogRef = this._dialog
            .open(UpdateNodeGroupComponent, {
              disableClose: true,
              width: "35vw",
              height: "50vh",
              data: {
                action: "create",
                depName: this.depName,
                nodeGroups: this.allDepPartitions.map(x => x.partitionName).join(","),
                isVdi: this.deployment?.isVdi
              },
            })
            .afterClosed()
            .subscribe((res) => {
              if (res) {
                this.snackBar.open(res, "Ok", {
                  duration: 5000,
                });
                this.refreshComponent();
              } else {
                return;
              }
            });
    }
    else if( this.deployment?.cloud?.toLowerCase() == CloudTypes.Google?.toLowerCase() || onlySlurm == false) {
      const dialogRef = this._dialog
      .open(NewUpdatePartitionComponent, {
        width: "60vw",
        disableClose: true,
        autoFocus: false,
        data: {
          depName: this.depName,
          title: "Create Node Group",
          partitionProp: null,
          cloud: this.deployment.cloud,
          action: "create",
          provider: this.cloudProviders.find((provider) => provider.providerName === this.deployment.cloud) 
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.snackBar.open(res, "Ok", {
            duration: 5000,
          });
          this.refreshComponent();
        } else {
          return;
        }
      });
    }
    else {
      const dialogRef = this._dialog
            .open(UpdateNodeGroupComponent, {
              disableClose: true,
              width: "35vw",
              height: "50vh",
              data: {
                action: "create",
                depName: this.depName,
                nodeGroups: this.allDepPartitions.map(x => x.partitionName).join(","),
                isVdi: this.deployment?.isVdi,
                provider: this.cloudProviders.find((provider) => provider.providerName === this.deployment.cloud) 
              },
            })
            .afterClosed()
            .subscribe((res) => {
              if (res) {
                this.snackBar.open(res, "Ok", {
                  duration: 5000,
                });
                this.refreshComponent();
              } else {
                return;
              }
            });
    }
  }

  updatePartition(part, onlySlurm = true) {
    if(this.deployment?.isVdi){
      const dialogRef = this._dialog
      .open(UpdateNodeGroupComponent, {
        disableClose: true,
        width: "35vw",
        height: "50vh",
        data: {
          action: "update",
          depName: this.depName,
          nodeGroups: part?.partitionName,
          isVdi: true
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.snackBar.open(res, "Ok", {
            duration: 5000,
          });
          this.refreshComponent();
        } else {
          return;
        }
      });
    }
    else if(this.deployment?.cloud?.toLowerCase() == CloudTypes.Google?.toLowerCase() || onlySlurm == false) {
      const dialogRef = this._dialog
      .open(NewUpdatePartitionComponent, {
        width: "45vw",
        disableClose: true,
        autoFocus: false,
        data: {
          depName: this.depName,
          title: "Update Node Group",
          partitionProp: part,
          cloud: this.deployment.cloud,
          action: "update",
          provider: this.cloudProviders.find((provider) => provider.providerName === this.deployment.cloud) 
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.snackBar.open(res, "Ok", {
            duration: 5000,
          });
          this.refreshComponent();
        } else {
          return;
        }
      });
    }
    else {
      const dialogRef = this._dialog
            .open(UpdateNodeGroupComponent, {
              disableClose: true,
              width: "35vw",
              height: "50vh",
              data: {
                action: "update",
                depName: this.depName,
                nodeGroups: part?.partitionName,
                //nodeGroups: this.allDepPartitions.map(x => x.partitionName).join(","),
                isVdi: this.deployment?.isVdi
              },
            })
            .afterClosed()
            .subscribe((res) => {
              if (res) {
                this.snackBar.open(res, "Ok", {
                  duration: 5000,
                });
                this.refreshComponent();
              } else {
                return;
              }
            });
    }
  }

  deletePartition(part, isVdi = false) {
    if(this.deployment?.isVdi) {
      const dialogRef = this._dialog
            .open(UpdateNodeGroupComponent, {
              disableClose: true,
              width: "400px",
              data: {
                action: "delete",
                depName: this.depName,
                nodeGroups: part?.partitionName,
                isVdi: true
              },
            })
            .afterClosed()
            .subscribe((res) => {
              if (res) {
                this.snackBar.open(res, "Ok", {
                  duration: 5000,
                });
                this.refreshComponent();
              } else {
                return;
              }
            });
    }
    else if(this.deployment?.cloud?.toLowerCase() == CloudTypes.Google?.toLowerCase()) {
      this._dialog
      .open(JobConfirmationDialogComponent, {
        width: "35%",
        autoFocus: false,
        disableClose: true,
        hasBackdrop: false,
        id: "jobActionConfirmDialog",
        data: {
          depName: this.depName,
          jobName: part.partitionName,
          actionText: "Delete Node Group",
          actionValue: -1,
          title: "Delete",
          message: "Do you want to ",
          noBtnText: "Cancel",
          yesBtnText: "Ok",
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          let depParams: DeploymentParameter[] = [];
          depParams.push({
            depKey: "partitionName",
            depValue: part.partitionName,
          });
          var depJsonBody = new DeploymentJsonBody(depParams);
          this.snackBar.open("Action is in progress.", "Ok", {
            duration: 5000,
          });
          let skipCloud = JSON.parse(JSON.stringify(res));
          this.depService
            .createUpdatePartition(
              3,
              this.deployment.cloud,
              depJsonBody,
              "delete",
              this.depName,
              res?.returnObject?.skipCloud
            )
            .subscribe({
              next: (data: any) => {
                this.snackBar.open(data?.actionMessage, "Ok", {
                  duration: 5000,
                });
                this.refreshComponent();
              },
              error: (err) => {
                this.snackBar.open(err.error?.actionMessage, "Ok", {
                  duration: 5000,
                });
              },
            });
        }
      });
    }
    else{
      const dialogRef = this._dialog
            .open(UpdateNodeGroupComponent, {
              disableClose: true,
              width: "400px",
              data: {
                action: "delete",
                depName: this.depName,
                nodeGroups: part?.partitionName,
                isVdi: this.deployment?.isVdi
              },
            })
            .afterClosed()
            .subscribe((res) => {
              if (res) {
                this.snackBar.open(res, "Ok", {
                  duration: 5000,
                });
                this.refreshComponent();
              } else {
                return;
              }
            });
    }
  }

  refreshComponent() {
    let url = this.router.url;
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(url)]);
    });
  }

  powerOnGracefully() {
    const dialogRef = this._dialog.open(PoweroffConfirmationComponent, {
      width: "30%",
      autoFocus: true,
      disableClose: true,
      data: { depName: this.depName, action: "Power On" },
    });
    dialogRef.afterClosed().subscribe(async (res) => {
      if (res) {
        this.depService.powerOnGracefully(this.depName).subscribe({
          next: (data: { actionMessage: string }) => {
            this.snackBar.open(data.actionMessage, "Ok", {
              duration: 5000,
            });
          },
          error: (err: HttpErrorResponse) => {
            this.snackBar.open(err.error.actionMessage, "Ok", {
              duration: 5000,
            });
          },
        });
      }
    });
  }

  powerOffGracefully() {
    const dialogRef = this._dialog.open(PoweroffConfirmationComponent, {
      width: "30%",
      autoFocus: true,
      disableClose: true,
      data: { depName: this.depName, action: "Power Off" },
    });
    dialogRef.afterClosed().subscribe(async (res) => {
      if (res) {
        this.depService.powerOffGracefully(this.depName).subscribe({
          next: (data: { actionMessage: string }) => {
            this.snackBar.open(data.actionMessage, "Ok", {
              duration: 5000,
            });
          },
          error: (err: HttpErrorResponse) => {
            this.snackBar.open(err.error.actionMessage, "Ok", {
              duration: 5000,
            });
          },
        });
      }
    });
  }

  onSearch(): void {
    this.filteredDeploymentDetails();
    this.filteredPartitions();
  }

  filteredDeployment : any[];
  filteredDeploymentDetails(stats: boolean = false) {
    const searchTermLower = this.searchTerm.toLowerCase();
    let syncstoreUsage = parseFloat(this.storage?.syncStoreUsage?.split(' ')[0] || '0');
    let workStoreUsage = parseFloat(this.storage?.workStoreUsage?.split(' ')[0] || '0');
    const storageUsed = syncstoreUsage + workStoreUsage;

    this.filteredDeployment = [
      { title: "Name", value: this.deployment?.name, link: false},
      { title: "Status", value: this.deployment?.status, link: false },,
      { title: "Location", value: this.deployment?.location, link: false },
      { title: "Scheduler", value: this.deployment?.scheduler, link: false },
      { title: "Infrastructure", value: this.deployment?.cloud, link: false },
      { title: "Total no. of Jobs", value: this.deployment?.noOfJobs, link: this.deployment?.numOfComputeNodes != 0 },
      { title: "Admin Username", value: this.deployment?.adminUsername, link: false },
      { title: "Deployed By", value: this.deployment?.profileUserId, link: false },
      {
        title: "Attached Users",
        value: this.usersAttached?.length,
        link: !!this.usersAttached?.length
      },
      {
        title: "Total Spend",
        value: this.deployment?.totalSpend + " HPC Units",
        link: false
      },
      { title: "Total Nodes", value: this.deployment?.totalNodes, link: true },
      {
        title: "No. of Compute Nodes",
        value: this.deployment?.numOfComputeNodes,
        link: false
      },
      { title: "Cores Per Node", value: this.deployment?.coresPerNode, link: false },
      { title: "Running Cores", value: this.deployment?.runningCores, link: false },
      { title: "Total CPU Cores", value: this.deployment?.maxNoOfCores, link: false },
      {
        title: "Total no. of Applications",
        value: this.deployment?.totalApplications,
        link: this.deployment?.numOfComputeNodes != 0
      },
      { title: "Number Of Workstations", value: this.noOfWorkstations, link: false },
      {
        title: "SyncHPC License Validity",
        value: this.daysRemaining + " Days",
        link: false
      },
      {
        title: "Elastic License Balance",
        value: this.deployment?.elasticLicenseBalance || "NA",
        link: false
      },
      {
        title: "Auto Delete Jobs Data",
        value: this.deployment?.deleteJobDataAfter
          ? "After " + this.deployment?.deleteJobDataAfter + " Days"
          : "NA",
        link: false
      },
      {
        title: "Auto Delete Jobs",
        value: this.deployment?.deleteJobsAfter
          ? "After " + this.deployment?.deleteJobsAfter + " Days"
          : "NA",
        link: false
      },
      {
        title: "Subnet IP Range",
        value: this.deployment?.subnetIpRange || "NA",
        link: false
      },
      {
        title: "Network IP Range",
        value: this.deployment?.networkIpRange || "NA",
        link: false
      }
    ].filter(
      (detail) =>
        detail.title.toLowerCase().includes(searchTermLower) ||
        (detail.value &&
          detail.value.toString().toLowerCase().includes(searchTermLower))
    );

    if(this.isVDIDeployment){
      this.filteredDeployment.push(
        {
          title: "Total Active Sessions",
          value: this.sessions?.length || 0,
          link: !!this.sessions?.length
        }
      );
    }
    else{
      this.filteredDeployment.push(
        { 
          title: "Storage "+(this.storage?.name || ''), 
          value: storageUsed+" GB"+" / "+(this.storage?.size || 0)+" GB", 
          link: true 
        }
      );
    }

    if(stats)  return this.filteredDeployment.filter(s => !isNaN(s.value) || s.title?.includes('Storage')).sort((a, b) => Number(b.link) - Number(a.link) || a.title.localeCompare(b.title));
    return this.filteredDeployment.filter(s => isNaN(s.value) && !s.title?.includes('Storage'));
  }

  filteredPartitions() {
    const searchTermLower = this.searchTerm.toLowerCase();
    return this.allDepPartitions.filter(
      (partition) =>
        partition.partitionName.toLowerCase().includes(searchTermLower) ||
        partition.instanceType.toLowerCase().includes(searchTermLower) ||
        partition.dynamicNodeCount
          .toString()
          .toLowerCase()
          .includes(searchTermLower) ||
        partition.staticNodeCount
          .toString()
          .toLowerCase()
          .includes(searchTermLower)
    );
  }

    checkDepStatus() {
      this._dialog.open(JobOutputDialogComponent, {
        width: '90%',
        autoFocus: false,
        disableClose: true,
        hasBackdrop: false,
        id: "jobOutputDialogJobs",
        data: { depName: this.deployment.name, depId: this.deployment.id, path: "", id: "jobOutputDialogJobs" },
        panelClass: 'custom-output-dialog-container'
      });
    }
  
    deleteDeployment() {
      const dialogRef = this._dialog.open(DeleteDeploymentComponent, {
        width: '30%',
        autoFocus: true,
        disableClose: true,
        data: { name: this.deployment.name, type: 'deployment'},
      })
      dialogRef.afterClosed().subscribe(async res => {
        if (res) {
          this.depService.deleteDeployment(this.deployment.name, res?.returnObject?.skipCloud).subscribe({
            next: (data) => {
              this.spiner.show();
              this.snackBar.open('Deployment Deleted Successfully, Wait For Some Time or Refresh Page Once.', 'Ok',
                {
                  duration: 3000
                })
              
              let route = decodeURIComponent(this.router.url).split('/')[1]; 
              this.router.navigate([route]);
            },
            error: (error) => {
              this.snackBar.open(error?.error?.message ||'Failed to delete deployment.', 'Ok', { duration: 3000 })
            }
          });
        }
      })
    }

    openLink(link: string) {
      if(link){
        if(link.toLowerCase().indexOf('nodes') != -1){
          this.router.navigate(['Nodes List', this.deployment.cloud, this.depName]);
        }
        else if(link.toLowerCase().indexOf('job') != -1){
          this.router.navigate(['Jobs List', this.deployment.cloud, this.depName]);
        }
        else if(link.toLowerCase().indexOf('application') != -1){
          this.router.navigate(['Applications List', this.deployment.cloud, this.depName]);
        }
        else if(link.toLowerCase().indexOf('storage') != -1){
          if(this.storage)
            this.router.navigate(['Storages List', this.deployment.cloud, this.depName, this.storage?.name]);
        }
        else if(link.toLowerCase().indexOf('sessions') != -1){
          this.router.navigate(['Session List', 'Sessions']);
        }
        else if(link.toLowerCase().includes('settings')){
          this.router.navigate(['Configurator', 'Deployment', this.deployment.cloud, this.depName, 'settings']);
        }
        else if(link.toLowerCase().includes('users')){
          this.router.navigate(['Users List', 'users', 'deployment', this.depName]);
        }
        else if (link.toLowerCase().includes('logs')) {
          let queryParams = {};
          queryParams = { type: "Deployment" };
          this.router.navigate(['Home', this.deployment.cloud, this.depName, 'Logs'], { queryParams });
        }
      }
    }

  getAllCloudProviders() {
    this.depService.getAllCloudProviders().subscribe((data) => {
      this.cloudProviders = <CloudProvider[]>JSON.parse(JSON.stringify(data));
      if (this.cloudProviders && this.cloudProviders.length > 0) {
        this.cloudProviders.forEach((provider) => {
          provider.providerIconFileName = `${this.providerImagePath}${provider.providerIconFileName}`;
        });
      }
    });
  }

  checkIfOnPremiseDeployment(){
    return this.deployment?.cloud != CloudTypes.OnPremise;
  }
}
